import { isUpcomingHold, nextHold } from '../helpers';

const HoldMembership = (props) => {
  const { clubMembership, onModal } = props;

  const handleEditHold = (e) => {
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data-id');
    onModal('editHold', id);
  };

  const handleDeleteHold = (e) => {
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data-id');
    onModal('deleteHold', id);
  };

  const handleAddHold = (e) => {
    e.preventDefault();
    onModal('addHold');
  };

  if (clubMembership.status === 'On Hold') {
    const currentHoldId = getCurrentHold(clubMembership);
    return (
      <a onClick={handleEditHold} data-id={currentHoldId}>
        Remove Hold
      </a>
    );
  }
  const isFuture = isUpcomingHold(clubMembership);
  if (isFuture) {
    const uHold = nextHold(clubMembership);
    return (
      <a
        onClick={handleDeleteHold}
        data-id={uHold.holdId}
        className="c7-club-actions__removehold"
      >
        Remove Hold
      </a>
    );
  }
  return (
    <a onClick={handleAddHold} className="c7-club-actions__hold">
      Put your club on hold
    </a>
  );
};

const getCurrentHold = (clubMembership) => {
  let today = new Date();
  today = today.toISOString();
  let currentHoldId = null;
  clubMembership.onHolds.forEach((onHold) => {
    if (onHold.startDate < today && onHold.endDate > today) {
      currentHoldId = onHold.id;
    }
  });
  return currentHoldId;
};

export default HoldMembership;
